import { render, staticRenderFns } from "./ModalLiberarRepasseMultiplo.vue?vue&type=template&id=f85c9f5e"
import script from "./ModalLiberarRepasseMultiplo.vue?vue&type=script&lang=ts"
export * from "./ModalLiberarRepasseMultiplo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports